import React from 'react'
import CartItem from './CartItem'

import {
  Grid,
  GridColumn,
  Header,
  Rail,
  Sticky,
  Segment,
  Item,
  Divider
} from 'semantic-ui-react'

export default ({ cart, contextRef, removeFromCart, addToCart }) => {
  const cartItems =
    cart.length > 0
      ? cart.map(cartItem =>
          <CartItem
            key={cartItem.id}
            product={cartItem}
            itemNeedsAttention={
              cartItem.qty > cartItem.v_productVariant.virtualinstock
            }
            smallButton={true}
            removeFromCart={removeFromCart}
            addToCart={addToCart}
          />
        )
      : <Header as="h4" textAlign="center">
          No Items in Cart
        </Header>

  return (
    <Rail
      as={Grid}
      position="right"
      style={{ width: '100%', maxWidth: 500 }}
      internal
      className="checkout-rail"
    >
      <Sticky
        as={GridColumn}
        only="large screen"
        context={contextRef}
        offset={65}
      >
        <Segment style={{ maxHeight: '85vh' }}>
          <Header as="h4" textAlign="center">
            Summary
          </Header>
          <Divider />
          <Item.Group style={{ maxHeight: '70vh', overflowY: 'auto' }}>
            {cartItems}
          </Item.Group>
        </Segment>
      </Sticky>
    </Rail>
  )
}



// WEBPACK FOOTER //
// ./src/components/CheckoutRail.jsx